import { useEffect, useState } from "react";

export default function UsersForm({ onSubmit, user }) {

  // ✅ État initial
  const initialForm = {
    nom: "",
    email: "",
    mot_de_passe: "",
    role: "TECHNICIEN"
  };

  const [form, setForm] = useState(initialForm);

  // 🔄 Remplissage en mode édition
  useEffect(() => {
    if (user) {
      setForm({
        nom: user.nom || "",
        email: user.email || "",
        mot_de_passe: "",        // 🔐 jamais afficher le mot de passe
        role: user.role || "TECHNICIEN"
      });
    } else {
      setForm(initialForm);
    }
  }, [user]);

  // ✍️ Gestion des changements
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // 🚀 Soumission
  const handleSubmit = (e) => {
    e.preventDefault();

    // 🧪 Debug utile
    console.log("FORM ENVOYÉ :", form);

    onSubmit(form);

    // 🧹 vider le formulaire seulement en création
    if (!user) {
      setForm(initialForm);
    }
  };

  return (
    <form className="client-form" onSubmit={handleSubmit}>

      <input
        type="text"
        name="nom"
        placeholder="Nom"
        value={form.nom}
        onChange={handleChange}
        required
      />

      <input
        type="email"
        name="email"
        placeholder="Email"
        value={form.email}
        onChange={handleChange}
        required
      />

      <input
        type="password"
        name="mot_de_passe"
        placeholder="Mot de passe"
        value={form.mot_de_passe}
        onChange={handleChange}
        required={!user} // obligatoire seulement à la création
      />

      <select
        name="role"
        value={form.role}
        onChange={handleChange}
        required
      >
        <option value="">-- Choisir un rôle --</option>
        <option value="ADMIN">ADMIN</option>
        <option value="TECHNICIEN">TECHNICIEN</option>
      </select>

      <button type="submit">
        {user ? "Mettre à jour" : "Enregistrer"}
      </button>

    </form>
  );
}
